import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import RoundedGainfulButton from "../../common/RoundedGainfulButton";
import styles from "./styles.module.scss";
import H2Font from "../../common/H2Font";
import LargeFont from "../../common/LargeFont";
import RegFont from "../../common/RegFont";
const ThankYouBanner = () => {
    const userData = useSelector((state) => state.accountSettings.userAccount);
    const history = useHistory();
    const { search } = useLocation();
    const urlSearchParams = new URLSearchParams(search);
    const showOrderDate = urlSearchParams.get("from") === "memberperk";
    const ordersDates = useSelector((state) => state.ordersInfo.nextOrderDates);
    const viewProfile = () => {
        if (urlSearchParams.has("from") &&
            urlSearchParams.get("from") === "memberperk") {
            history.push("/app/subscription/");
        }
        else {
            history.push("/app/onbording-steps");
        }
    };
    const getCopy = () => {
        if (showOrderDate) {
            return `You’ve successfully claimed your offer and changed your billing date to ${ordersDates.nextBillDate}. We’ve received your change and your confirmation will be sent to ${userData.email} with your updated tracking information.`;
        }
        else {
            return `Thank you for your order, ${userData.name.split(" ")[0]}. We've received your order and your confirmation will be sent to ${userData.email} email with your tracking information.`;
        }
    };
    return (_jsx("div", { className: styles.wrapper, children: _jsxs("div", { className: styles.banner, children: [_jsx(H2Font, { children: showOrderDate
                        ? "Your Month Just Got Even Better"
                        : "Better health is just around the corner" }), _jsx("div", { className: styles.subtitle, children: _jsx(LargeFont, { children: getCopy() }) }), showOrderDate && ordersDates.nextBillDate && (_jsxs("div", { className: styles.order_date, children: [_jsx(RegFont, { fontWeight: 400, children: "Next Order Date" }), _jsx(RegFont, { children: ordersDates.nextBillDate })] })), _jsx(RoundedGainfulButton, { label: "View Profile", onClick: viewProfile }), _jsxs("p", { className: styles.fsa, children: ["This order is eligible for HSA/FSA reimbursement.", " ", _jsx("a", { href: "https://app.truemed.com/qualify/tm_qual_4z4mvhfi0t?utm=post_purchase", children: "Qualify here" })] })] }) }));
};
export default ThankYouBanner;
